import {Stack, Tooltip, TooltipProps, Typography} from "@mui/material";
import {ReactElement} from "react";
import {useAppSelector} from "store";

interface ShortcutLabelProps {
  prefix?: ReactElement;
  separator?: string;
  keys: string[];
}

const ShortcutLabel = ({prefix, keys, separator = "|"}: ShortcutLabelProps) => (
  <Stack direction={"row"} spacing={1} sx={{alignItems: "center"}}>
    {prefix &&  <Typography variant={"body1"}>{prefix}</Typography>}
    <Typography variant={"caption"}>
      {
        keys.map((key, index) => (
          <>
            <span
              style={
                {
                  display: "inline-block",
                  padding: "1px 5px",
                  border: "1px solid #fff",
                  borderRadius: "6px",
                  fontWeight: "bold"
                }
              }
            >
              {key}
            </span>
            {index < keys.length - 1 && <span> {separator} </span>}
          </>
        ))
      }
    </Typography>
  </Stack>
);

function ShortcutTooltip({keys, prefix, separator, ...rest}: Omit<TooltipProps, "title" | "open" | "arrow"> & ShortcutLabelProps) {
  const isHotkeyOverlayDisplayed = useAppSelector(state => state.hotkeys.isOverlayDisplayed);

  return (
    <Tooltip
      {...rest}
      open={isHotkeyOverlayDisplayed}
      title={<ShortcutLabel keys={keys} prefix={prefix} separator={separator}/>}
      arrow
    />
  );
}

export {ShortcutLabel, ShortcutTooltip};
